module.exports = __webpack_public_path__ + "static/media/holistic.802405ec.jpg";